import {assert} from 'Asserts';
import {ClientId} from 'notebook/ELNConstants';
import {
  ArchivedFieldColumnDefinition,
  SchemaFieldColumnDefinition,
} from 'notebook/structured-tables/columns/ColumnDefinitions';
import isReadOnly from 'notebook/structured-tables/columns/isReadOnly';
import {TableColumnType} from 'notebook/tables/constants/TableColumnConstants';
import {SchemaField} from 'schemas/fields/SchemaFieldConstants';

import {BaseTagValueStructuredTableColumn} from '../StructuredTableConstants';

export function toSchemaFieldColumnDefinition(
  schemaField: SchemaField,
  structuredTableColumn: BaseTagValueStructuredTableColumn<ClientId>
): (SchemaFieldColumnDefinition | ArchivedFieldColumnDefinition) & {
  columnGroup?: SchemaFieldColumnDefinition['columnGroup'];
} {
  const columnGroup =
    structuredTableColumn.columnGroup != null
      ? {columnGroup: structuredTableColumn.columnGroup}
      : {columnGroup: null};

  const locked = isReadOnly(structuredTableColumn);
  if (structuredTableColumn.isArchived) {
    return {
      type: TableColumnType.MISSING_FIELD,
      structuredTableColumnName: structuredTableColumn.name,
      ...columnGroup,
      locked,
      isRequired: structuredTableColumn.isRequired,
      isArchived: structuredTableColumn.isArchived,
      tagSchemaFieldType: structuredTableColumn.schemaFieldType,
      tagSchemaFieldApiId: structuredTableColumn.schemaFieldApiId,
      tagSchemaFieldDisplayName: structuredTableColumn.schemaFieldDisplayName,
      tagSchemaFieldIsComputed: structuredTableColumn.schemaFieldIsComputed,
      tagSchemaFieldIsConvertedFromLink: structuredTableColumn.schemaFieldIsConvertedFromLink || false,
      tagSchemaFieldIsSnapshot: structuredTableColumn.schemaFieldIsSnapshot,
      schemaField,
    };
  } else {
    assert(
      structuredTableColumn.schemaFieldApiId != null,
      'schemaFieldApiId is expected to exist for TAG_VALUE columns if schemaField is found'
    );
    return {
      type: TableColumnType.TAG_VALUE,
      selector: structuredTableColumn.selector,
      ...columnGroup,
      locked,
      isRequired: structuredTableColumn.isRequired,
      tagSchemaFieldType: structuredTableColumn.schemaFieldType,
      tagSchemaFieldApiId: structuredTableColumn.schemaFieldApiId,
      tagSchemaFieldDisplayName: structuredTableColumn.schemaFieldDisplayName,
      tagSchemaFieldDescription: structuredTableColumn.schemaFieldDescription,
      tagSchemaFieldDecimalPrecision: structuredTableColumn.schemaFieldDecimalPrecision,
      tagSchemaFieldIsComputed: structuredTableColumn.schemaFieldIsComputed,
      tagSchemaFieldIsConvertedFromLink: structuredTableColumn.schemaFieldIsConvertedFromLink || false,
      tagSchemaFieldIsSnapshot: structuredTableColumn.schemaFieldIsSnapshot,
      unitApiIdentifier: structuredTableColumn.unitApiIdentifier ?? null,
      schemaField,
    };
  }
}
